import React from "react";
import { Select } from "antd";

const SortTo = (props) => {
  // -------------------------- VAR --------------------------
  const { status, setStatus } = props;
  const options = [
    { label: "All", value: "All" },
    { label: "Confirmed", value: "confirmed" },
    { label: "To be confirmed", value: "unconfirmed" },
  ];
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const onChange = (value) => {
    setStatus(value);
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Select
      style={{ width: "100%" }}
      options={options}
      placeholder="Status"
      value={status}
      onChange={(value) => onChange(value)}
    />
  );
};

export default SortTo;
